import React from 'react';
import Chart from 'react-apexcharts';

const ChartTest = () => {
  // ApexCharts Bar Chart Config
  const barOptions = {
    chart: { type: 'bar', height: 300 },
    xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May'] },
    colors: ['#3b82f6'],
    plotOptions: { bar: { horizontal: false } },
  };
  const barSeries = [{ name: 'Sales', data: [12, 19, 3, 5, 2] }];

  // ApexCharts Line Chart Config
  const lineOptions = {
    chart: { type: 'line', height: 300 },
    xaxis: { categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'] },
    colors: ['#10b981'],
    stroke: { curve: 'smooth' },
  };
  const lineSeries = [{ name: 'Views', data: [33, 53, 85, 41, 44] }];

  // ApexCharts Pie Chart Config
  const pieOptions = {
    chart: { type: 'pie', height: 300 },
    labels: ['Red', 'Blue', 'Yellow'],
    colors: ['#ef4444', '#3b82f6', '#eab308'],
  };
  const pieSeries = [300, 50, 100];

  // ApexCharts Donut Chart Config
  const donutOptions = {
    chart: { type: 'donut', height: 300 },
    labels: ['Category A', 'Category B', 'Category C'],
    colors: ['#8b5cf6', '#ec4899', '#f59e0b'],
  };
  const donutSeries = [30, 40, 30];

  // ApexCharts Grouped Bar Chart Config
  const groupedBarOptions = {
    chart: { type: 'bar', height: 300 },
    xaxis: { categories: ['Q1', 'Q2', 'Q3', 'Q4'] },
    colors: ['#3b82f6', '#10b981', '#8b5cf6'],
    plotOptions: { bar: { horizontal: false } },
    legend: { position: 'bottom' },
  };
  const groupedBarSeries = [
    { name: 'Product A', data: [12, 19, 8, 15] },
    { name: 'Product B', data: [10, 15, 12, 18] },
    { name: 'Product C', data: [8, 11, 14, 10] },
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
          ApexCharts Test Page
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Testing ApexCharts (SVG-based library) - Third attempt
        </p>
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-8">
          <p className="text-sm text-blue-800 dark:text-blue-300">
            💡 <strong>Also check:</strong> Navigate to <code className="bg-white dark:bg-gray-700 px-2 py-1 rounded">/simple-charts</code> to see HTML/CSS charts (guaranteed to work)
          </p>
        </div>

        {/* Grid of charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          
          {/* Test 1: Bar Chart */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Test 1: Bar Chart (ApexCharts)
            </h2>
            <Chart
              options={barOptions}
              series={barSeries}
              type="bar"
              height={300}
            />
            <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
              Should show: Blue bars for Jan-May with values
            </p>
          </div>

          {/* Test 2: Line Chart */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Test 2: Line Chart (ApexCharts)
            </h2>
            <Chart
              options={lineOptions}
              series={lineSeries}
              type="line"
              height={300}
            />
            <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
              Should show: Green line graph Mon-Fri
            </p>
          </div>

          {/* Test 3: Pie Chart */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Test 3: Pie Chart (ApexCharts)
            </h2>
            <Chart
              options={pieOptions}
              series={pieSeries}
              type="pie"
              height={300}
            />
            <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
              Should show: Red, Blue, Yellow pie slices
            </p>
          </div>

          {/* Test 4: Doughnut Chart */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Test 4: Doughnut Chart (ApexCharts)
            </h2>
            <Chart
              options={donutOptions}
              series={donutSeries}
              type="donut"
              height={300}
            />
            <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
              Should show: Purple, Pink, Orange doughnut
            </p>
          </div>

        </div>

        {/* Test 5: Bar Chart with Multiple Datasets */}
        <div className="mt-6 bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Test 5: Grouped Bar Chart (ApexCharts - Like Monthly Activity)
          </h2>
          <Chart
            options={groupedBarOptions}
            series={groupedBarSeries}
            type="bar"
            height={300}
          />
          <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
            Should show: 3 grouped bars (Blue, Green, Purple) per quarter
          </p>
        </div>

        {/* Debugging Info */}
        <div className="mt-6 bg-blue-50 dark:bg-blue-900/20 rounded-lg p-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Debugging Information
          </h2>
          <div className="space-y-2 text-sm text-gray-700 dark:text-gray-300 font-mono">
            <p>✓ ApexCharts Library (SVG-based)</p>
            <p>✓ Chart component loaded: {Chart ? 'Yes' : 'No'}</p>
            <p className="mt-4 text-blue-600 dark:text-blue-400">
              Attempt #3: Chart.js (Canvas) → Nivo (SVG) → ApexCharts (SVG)
            </p>
            <p className="mt-2 text-orange-600 dark:text-orange-400">
              If charts still don't show, check /simple-charts for HTML/CSS version
            </p>
          </div>
          <div className="mt-4 p-4 bg-white dark:bg-gray-800 rounded">
            <p className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
              Instructions:
            </p>
            <ol className="list-decimal list-inside space-y-1 text-sm text-gray-600 dark:text-gray-400">
              <li>Check which charts are visible above</li>
              <li>Open browser console (F12) for any errors</li>
              <li>Take a screenshot showing which tests work</li>
              <li>Report back which charts you can see</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChartTest;
